
      document.addEventListener('DOMContentLoaded', function () {
        function isIE() {
          const ua = window.navigator.userAgent;
          const msie = ua.indexOf('MSIE ');
          const trident = ua.indexOf('Trident/');

          return msie > 0 || trident > 0;
        }

        if (!isIE()) return;
        const hiddenInput = document.querySelector('#product-form-template--33094172016965__main input[name="id"]');
        const noScriptInputWrapper = document.createElement('div');
        const variantSwitcher =
          document.querySelector('variant-radios[data-section="template--33094172016965__main"]') ||
          document.querySelector('variant-selects[data-section="template--33094172016965__main"]');
        noScriptInputWrapper.innerHTML = document.querySelector(
          '.product-form__noscript-wrapper-template--33094172016965__main'
        ).textContent;
        variantSwitcher.outerHTML = noScriptInputWrapper.outerHTML;

        document.querySelector('#Variants-template--33094172016965__main').addEventListener('change', function (event) {
          hiddenInput.value = event.currentTarget.value;
        });
      });
    